/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HumanityDailyTrxInfo } from './HumanityDailyTrxInfo';

export type HumanityHomeTotalTrxInfo = {
    TRXHTP: HumanityHomeTotalTrxInfo.TRXHTP;
    TRXTP: HumanityHomeTotalTrxInfo.TRXTP;
    DAVGTRXC: string;
    CNGP: string;
    DTRXLIST: Array<HumanityDailyTrxInfo>;
};

export namespace HumanityHomeTotalTrxInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
        CLAIM = 'CLAIM',
        DEPOSIT = 'DEPOSIT',
        USER = 'USER',
        AVG_GAS_PRICE = 'AVG_GAS_PRICE',
    }


}

